const types = {
  THUMBNAIL: 'THUMBNAIL'
}

export default types
